__webpack_require__.p = "/popover-search-ionic/";